var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'layout--main',
    {
      'layout--main_bg-gray': _vm.isGrayBackground,
    },
  ]},[_c('a',{ref:"skipLink",staticClass:"sr-only",attrs:{"href":"#main"}},[_vm._v(_vm._s(_vm.$t('a11y.skipToMainContent')))]),_c('TheSidebar',{attrs:{"sidebarItems":_vm.sidebarComputedItems}}),_c('transition',{attrs:{"name":_vm.routerTransition}},[_c('main',{class:[
        'content-wrapper',
        {
          'content-wrapper_small': _vm.isGrayBackground,
        },
      ],attrs:{"id":"main","role":"main","aria-labelledby":"page-title"}},[(_vm.pageTitle)?_c('header',{class:[
          'header',
          {
            'sr-only': _vm.isGrayBackground,
            header_sticky: !_vm.isGrayBackground,
          },
        ],attrs:{"role":"banner"}},[_c('h1',{attrs:{"id":"page-title"}},[_vm._v(_vm._s(_vm.pageTitle))])]):_vm._e(),_c('router-view'),_c('TheFooter')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }